import { useMutation } from '@tanstack/react-query';

import type {
  BookingGroupSessionMutationResponse,
  CancelBookingGroupSessionData,
} from '@/types/api/mutations';

import { HttpClient } from '@/network/HttpClient';

export const useCancelBookingGroupSessionMutation = () =>
  useMutation({
    mutationFn: (params: {
      url: string;
      data: CancelBookingGroupSessionData;
    }) =>
      HttpClient.request<BookingGroupSessionMutationResponse>({
        method: 'PUT',
        url: `${params.url}/cancel`,
        data: { group_session: params.data },
      }),
  });
